import React from 'react';
interface CategoryTitleProps {
  categoryPageTitle: string;
}

const CategoryTitle: React.FC<CategoryTitleProps> = ({ categoryPageTitle }) => {
  return (
    <div className={`mt-ll-3 mt-lg-ll-5`}>
      <h2 className="fw-bold fs-ll-sm-25 fs-ll-lg-27 text-center text-lg-start">
        {categoryPageTitle}
      </h2>
    </div>
  );
};

export default CategoryTitle;
